import { transitionDuration as e } from "@leafygreen-ui/tokens";
var n = e.slower,
  t = function () {
    var e, n;
    if ("undefined" != typeof window) {
      var t = {
        setRippleListener: !1,
        registeredRippleElements: new WeakMap()
      };
      return null !== (n = (e = window).__LEAFYGREEN_UTILS__) && void 0 !== n || (e.__LEAFYGREEN_UTILS__ = {
        modules: {}
      }), window.__LEAFYGREEN_UTILS__.modules["@leafygreen-ui/ripple"] = t, window.__LEAFYGREEN_UTILS__.modules["@leafygreen-ui/ripple"];
    }
  }();
function i(e) {
  null != t && t.registeredRippleElements.has(e.target) && function (e) {
    var n = e.target,
      i = null == t ? void 0 : t.registeredRippleElements.get(n);
    if (!n || !i) return;
    var o = i.backgroundColor,
      r = n.getBoundingClientRect(),
      a = document.createElement("span");
    a.className = "lg-ui-ripple", a.style.height = a.style.width = Math.max(r.width, r.height) + "px", n.appendChild(a);
    var s = e.pageY - r.top - a.offsetHeight / 2 - document.body.scrollTop,
      l = e.pageX - r.left - a.offsetWidth / 2 - document.body.scrollLeft;
    a.style.top = s + "px", a.style.left = l + "px", a.style.background = o, setTimeout(function () {
      a.remove();
    }, 750);
  }(e);
}
function o(e, n) {
  if (t) {
    if (t.registeredRippleElements.set(e, n), !t.setRippleListener) {
      document.addEventListener("click", i, {
        passive: !0
      });
      var o = document.createElement("style");
      o.innerHTML = r, document.head.append(o), t.setRippleListener = !0;
    }
    return function () {
      t.registeredRippleElements.delete(e);
    };
  }
}
var r = "\n  @-webkit-keyframes lg-ui-ripple {\n    from {\n      opacity:1;\n    }\n    to {\n      transform: scale(2);\n      transition: opacity ".concat(n, "ms;\n      opacity: 0;\n    }\n  }\n\n  @-moz-keyframes lg-ui-ripple {\n    from {\n      opacity:1;\n    }\n    to {\n      transform: scale(2);\n      transition: opacity ").concat(n, "ms;\n      opacity: 0;\n    }\n  }\n\n  @keyframes lg-ui-ripple {\n    from {\n      opacity:1;\n    }\n    to {\n      transform: scale(2);\n      transition: opacity ").concat(n, "ms;\n      opacity: 0;\n    }\n  }\n\n  .lg-ui-ripple {\n    position: absolute;\n    border-radius: 100%;\n    transform: scale(0.2);\n    opacity: 0;\n    pointer-events: none;\n    // Ensures that text is shown above ripple effect\n    z-index: -1;\n    -webkit-animation: lg-ui-ripple .75s ease-out;\n    -moz-animation: lg-ui-ripple .75s ease-out;\n    animation: lg-ui-ripple .75s ease-out;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    .lg-ui-ripple {\n      animation: none;\n      transform: none;\n    }\n  }\n");
export { o as registerRipple };